import {makeStyles} from "@material-ui/core";
import AppColors from './../colors/AppColors';
import Dimens from './../dimensions/Dimens';

export const useWelcomeStyle = makeStyles((theme) => ({
    offset: {
        marginTop: Dimens.APP_BAR_HEIGHT
    },
    grow: {
        flexGrow: 1
    },
    appBar: {
        backgroundColor: AppColors.APP_BAR_BACKGROUND_COLOR,
        height: Dimens.APP_BAR_HEIGHT,
        justifyContent: 'center',
    },
    features: {
        marginLeft: 35,
        fontSize: 16,
        fontWeight: 600,
        letterSpacing: 0.5,
        cursor: 'pointer'
    },
    current_price: {
        marginLeft: 35,
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: 0.5,
        cursor: 'pointer',
        color: AppColors.ACCENT_COLOR,
    },
    authButton: {
        color: AppColors.WHITE,
        paddingLeft: 15,
        paddingRight: 15,
        fontSize: 16,
        fontWeight: 600,
        textTransform: 'none',
        backgroundColor: AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 30),
        transition: 'all .2s ease-in-out',
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 30),
        },
        [theme.breakpoints.between(999, 1920)]: {
            alignSelf: 'center',
            height: 40,
            width: 100,
        }
    },
    signUpButton: {
        marginRight: 30,
        marginLeft: 20,
        [theme.breakpoints.between(999, 1920)]: {
            alignSelf: 'center',
            height: 40,
        }
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.between(750, 1920)]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.between(750, 1920)]: {
            display: 'none',
        },
    },
    mobileMenu: {
        display: 'flex',
        flexDirection: 'column',
    },
    popover: {
        pointerEvents: 'auto',
    },
    mobileMenuPaper: {
        backgroundColor: AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 10),
    },
    closeIcon: {
        color: AppColors.WHITE,
        cursor: 'pointer',
        margin: 16,
        '&:hover': {
            color: AppColors.lightenOrDarken(AppColors.ACCENT_COLOR, 90),
        }
    },
    loginButton: {
        color: AppColors.WHITE,
        borderColor: AppColors.WHITE,
        borderWidth: 2,
        paddingLeft: 15,
        paddingRight: 15,
        fontSize: 16,
        marginRight: 10,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        '&:hover': {
            transform: 'scale(0.9)',
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: 10,
        }
    },
    desktopLogin: {
        color: AppColors.WHITE,
        borderColor: AppColors.WHITE,
        borderWidth: 2,
        fontWeight: 600,
        fontSize: 14,
        paddingLeft: 15,
        paddingRight: 15,
        marginLeft: 10,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        '&:hover': {
            transform: 'scale(0.9)',
        },
        [theme.breakpoints.between(999, 1920)]: {
            alignSelf: 'center',
            height: 39,
        }
    },
    desktopLoginFilled: {
        color: AppColors.WHITE,
        fontWeight: 600,
        border: 'none !important',
        fontSize: 14,
        paddingLeft: 15,
        paddingRight: 15,
        marginLeft: 10,
        backgroundColor: '#4caf50',
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: '#4caf50',
        },
        [theme.breakpoints.between(999, 1920)]: {
            alignSelf: 'center',
            height: 39,
        }
    },
    signUpPrimary: {
        paddingLeft: 15,
        paddingRight: 15,
        fontSize: 16,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        color: AppColors.WHITE,
        backgroundColor: AppColors.PRIMARY_COLOR,
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 30),
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: 10,
        },
    },
    miniAuthFields: {
        borderRadius: 2,
        marginRight: 10,
        backgroundColor: AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 15),
        '& > *': {
            fontSize: 14,
            fontWeight: 400,
            color: AppColors.GREY_TEXT,
        },
        '& input:-webkit-autofill': {
            WebkitTextFillColor: `${AppColors.WHITE}`,
            caretColor: AppColors.WHITE,
            WebkitBoxShadow: `0 0 0 1000px ${AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 15)} inset`
        },
        '& label': {
            color: AppColors.GREY_TEXT,
            fontWeight: 600,
        },
        '& label.Mui-focused': {
            color: AppColors.ACCENT_COLOR,
        },
        '& label.Mui-disabled': {
            color: AppColors.ACCENT_COLOR,
        },
        '& input': {
            color: AppColors.WHITE,
            fontWeight: 600,
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: `${AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 30)}`,
                borderWidth: 2.3,
                borderRadius: 2,
                borderStyle: 'dotted',
            },
            '&:hover fieldset': {
                borderColor: `${AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 50)}`,
            },
            '&.Mui-focused fieldset': {
                borderColor: `${AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 60)}`,
            },
        },
    },
    fullScreenAuthFields: {
        borderRadius: 2,
        marginRight: 10,
        '& > *': {
            fontSize: 14,
            fontWeight: 400,
            color: AppColors.GREY_TEXT,
        },
        '& label': {
            fontWeight: 600,
        },
        '& label.Mui-focused': {
            color: AppColors.PRIMARY_COLOR,
        },
        '& label.Mui-disabled': {
            color: AppColors.PRIMARY_COLOR,
        },
        '& input': {
            color: AppColors.BLACK,
            fontWeight: 600,
        },

    },
    fabButton: {
        position: 'fixed',
        zIndex: 1,
        bottom: 30,
        right: 60,
    },
    fabRoot: {
        backgroundColor: 'white'
    },
    rememberMeLabelStyle: {
        fontSize: 10,
        color: `${AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 80)}`,
    },
    rememberMeCheckStyle: {
        color: `${AppColors.lightenOrDarken(AppColors.GREY_TEXT, 10)}`,
        '&:checked': {
            color: AppColors.ACCENT_COLOR,
        },
    },
    orangeChecked: {
        backgroundColor: '#F1952D',
        width: 15,
        borderRadius: 2,
        height: 15,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 15,
            height: 15,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#F1952D',
        },
    },
    outlinedInput: {
        color: 'white'
    }
}))
